import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import officeService from "./officeService";
import { setServerError } from "../error500/error500Slice";

const initialState = {
  offices: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const getOffice = createAsyncThunk(
  "offices/getOffice",
  async (_, thunkApi) => {
    try {
      return await officeService.getOffice();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (
        error.response &&
        (error.response.status === 500 || error.response.status === 503)
      ) {
        thunkApi.dispatch(setServerError(true));
      }

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const officeSlice = createSlice({
  name: "office",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getOffice.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.offices = action.payload;
    });
  },
});

export const { reset } = officeSlice.actions;
export default officeSlice.reducer;
